/** Iter 632 — customer wizard · streak milestone cheer (moved verbatim from EngageWizardSteps.jsx). */
import React from "react";
import { useShareStreak } from "@/hooks/useShareStreak";

/**
 * Iter-600 §2 — big gold cheer on the done screen when the customer's
 * latest post landed exactly on a milestone (server-side streak).
 */
export default function StreakMilestoneCard() {
  const q = useShareStreak();
  if (!q.data?.milestone_hit) return null;
  return (
    <div
      className="mt-4 rounded-xl bg-gradient-to-br from-amber-400 to-yellow-500 text-white text-center px-4 py-4 shadow-card"
      data-testid="engage-streak-milestone-done"
    >
      <div className="text-lg font-black">🔥 {q.data.posts_total} shared posts!</div>
      <div className="mt-0.5 text-[11px] font-semibold opacity-90">Milestone reached — you&apos;re a local legend</div>
    </div>
  );
}
